export const configuracionRoutesMap = {
  parametrosSistema: {
    path: '/configuracion/parametros-sistema',
    name: 'Parámetros del sistema',
  },
  detalleExtra: {
    path: '/configuracion/facturaDetalleExtra',
    name: 'Factura Detalle Extra',
  },
  misMetodosPago: {
    path: '/configuracion/misMetodosPago',
    name: 'Mis métodos de pago',
  },
}
